export default "__VITE_ASSET__e2133b55__"